import capitalize from 'lodash/capitalize';
import uniq from 'lodash/uniq';

import { WorkloadEventType, WorkloadOptimizationEvent } from '@cast/types';

import { eventTypeConfigMap } from '../../_constants';
import { PreparedEvent } from '../../types';

const getNames = (containers?: Array<{ name: string }>): string[] =>
  containers?.map(({ name }) => name) || [];

const getConfigContainerNames = (
  containers?: Array<{ containerName: string }>
): string[] => containers?.map(({ containerName }) => containerName) || [];

export const prepareEvent = ({
  event,
  type,
  ...rest
}: WorkloadOptimizationEvent): PreparedEvent => {
  return {
    timestamp: rest.createdAt,
    displayName: eventTypeConfigMap[type]?.name || type,
    displayNameShort: (() => {
      switch (type) {
        case WorkloadEventType.RECOMMENDED_REQUESTS_CHANGED:
          return `Rec. generated: ${capitalize(
            event.recommendedRequestsChanged?.applyType
          )}`;
        case WorkloadEventType.CONFIGURATION_CHANGEDV2:
          return 'Config. changed';
        case WorkloadEventType.RECOMMENDED_POD_COUNT_CHANGED:
          return 'Pod Count Rec. Changed';
        default:
          return eventTypeConfigMap[type]?.name || type;
      }
    })(),
    color: eventTypeConfigMap[type]?.color ?? 'grey.200',
    containerNames: (() => {
      switch (type) {
        case WorkloadEventType.SURGE:
          return getNames(event.surge?.containers);
        case WorkloadEventType.OOM_KILL:
          return getNames(event.oomKill?.containers);
        case WorkloadEventType.RECOMMENDED_REQUESTS_CHANGED:
          return uniq([
            ...getNames(event.recommendedRequestsChanged?.previous.containers),
            ...getNames(event.recommendedRequestsChanged?.current.containers),
          ]);
        case WorkloadEventType.CONFIGURATION_CHANGEDV2:
          return uniq([
            ...getConfigContainerNames(
              event.configurationChangedV2?.previous.workloadConfig.vpaConfig
                .containerConstraints
            ),
            ...getConfigContainerNames(
              event.configurationChangedV2?.current.workloadConfig.vpaConfig
                .containerConstraints
            ),
          ]);
        case WorkloadEventType.STARTUP_FAILURE:
          return getNames(event.startupFailure?.containers);
        case WorkloadEventType.CPU_PRESSURE:
          return getNames(event.cpuPressure?.containers);
        case WorkloadEventType.CPU_PRESSURE_RESOLVED:
          return getNames(event.cpuPressureResolved?.containers);
        default:
          return [];
      }
    })(),
    type,
    details:
      event.oomKill ||
      event.surge ||
      event.failedHook ||
      event.configurationChangedV2 ||
      event.recommendedRequestsChanged ||
      event.recommendedPodCountChanged ||
      event.scalingPolicyAssigned ||
      event.scalingPolicyCreated ||
      event.scalingPolicyUpdated ||
      event.scalingPolicyDeleted ||
      event.scalingPolicyOrderUpdated ||
      event.systemOverrideReset ||
      event.systemOverrideTriggered ||
      event.startupFailure ||
      event.cpuPressure ||
      event.cpuPressureResolved ||
      {},
    ...rest,
  };
};
